import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const MixedVegIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-mixedVeg"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M36.046 17.229c3.05-1.318 6.942-1.767 11.685-.858l.493.098-.204.98c-4.764-.996-8.61-.584-11.578.698-.624.27-1.154.557-1.59.843l-.226.153-.164.12-.104.085-.661-.75c.402-.355 1.183-.865 2.349-1.37"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="m44.412 7.88.708.708-14.766 14.766-.708-.708z"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M36.53 4.775c1.038 4.968.604 9.024-.759 12.179-.465 1.077-.936 1.824-1.284 2.25l-.085.1-.75-.662.084-.104.121-.164.153-.226c.286-.437.574-.967.843-1.59 1.238-2.866 1.664-6.55.797-11.089l-.098-.49z"
        />
        <path
          fill="#0050B3"
          className={styles.interactiveColor}
          d="M50.302 14.853c.25-.144.49-.311.701-.523 1.366-1.366 1.323-3.623-.097-5.042a3.7 3.7 0 0 0-1.423-.878c.694-1.335.468-3.045-.69-4.203s-2.869-1.384-4.203-.691a3.7 3.7 0 0 0-.878-1.423C42.293.674 40.036.631 38.67 1.997a3.3 3.3 0 0 0-.523.701c-1.562-.925-3.397-.892-4.5.211-1.366 1.365-1.092 3.853.611 5.556.863.863 1.928 1.357 2.946 1.458.287 1.205 1.041 2.529 2.192 3.68s2.476 1.905 3.681 2.193c.101 1.018.595 2.083 1.458 2.946 1.703 1.703 4.191 1.976 5.556.611 1.103-1.103 1.136-2.938.211-4.5"
        />
        <path
          fill="#ffffff"
          className={styles.white}
          d="M36.5 18a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M30 11a7 7 0 1 0 0 14 7 7 0 0 0 0-14m0 1a6 6 0 1 1 0 12 6 6 0 0 1 0-12"
        />
        <path
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          d="m18.125 7.999 1 .001c0 .945.218 1.79.582 2.524.188.379.373.652.503.808l.052.06-.737.676c-.188-.206-.453-.575-.713-1.1a6.6 6.6 0 0 1-.68-2.64z"
        />
        <path
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          d="m16.725 8.022 3.433 3.444-.709.706-3.433-3.444z"
        />
        <path
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          d="M16 10.118a6.6 6.6 0 0 1 2.963.692c.46.23.801.463 1.017.645l.085.075-.679.734c-.14-.13-.435-.342-.87-.56a5.6 5.6 0 0 0-2.206-.578l-.311-.008z"
        />
        <path
          fill="#ffffff"
          className={styles.white}
          d="m28.943 23.425.466-.39a1.54 1.54 0 0 0 .276-2.06l-7.07-10.162a1.54 1.54 0 0 0-2.252-.301l-2.148 1.796a1.54 1.54 0 0 0-.1 2.269l8.752 8.756a1.54 1.54 0 0 0 2.076.092"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="m20.042 10.128-2.148 1.796a2.04 2.04 0 0 0-.134 3.006l8.753 8.756c.748.746 1.941.8 2.75.122l.467-.39c.81-.677.969-1.861.366-2.728l-7.071-10.163a2.04 2.04 0 0 0-2.983-.4m2.162.97 7.07 10.163a1.04 1.04 0 0 1-.185 1.39l-.467.39a1.04 1.04 0 0 1-1.402-.062l-8.752-8.756a1.04 1.04 0 0 1 .068-1.532l2.148-1.796a1.04 1.04 0 0 1 1.52.203"
        />
        <path fill="#ffffff" className={styles.white} d="M16 32h36V18H16z" />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M53 17H15v16h38zm-2 2v12H17V19z"
        />
        <path
          fill="#0050B3"
          className={styles.interactiveColor}
          d="M49 21.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 49 21.5m0 7a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 49 28.5m-27-7a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 22 21.5m0 7a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 22 28.5"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          d="M33.538 15.003a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-2.624-1.824a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-3 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M52 24v2H16v-2z"
        />
      </g>
    </Icon>
  )
}
